export const HOST = () => {
    var url = window.location.href;
    // url = "http://pitaatto.eplatform.vn";
    var arr = url.split("/");
    return arr[0] + "//" + arr[2]
}

export const UNSET_OPTION = '';


// Directions API
// Maps JavaScript API
// Places API
// Google Maps API キーは環境変数から読む（コミットしない）。
// ClientApp/.env に REACT_APP_GOOGLE_MAP_KEY=... を置く（.env は gitignore）。
// 未設定時は従来の PRODUCT キーにフォールバック。
export const API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY || 'AIzaSyBjb_zoxIWFKIa92maBbXYMhJtLWFPrD-w';
//  DEVELOP 'AIzaSyBGXcH9oK7erRfKSXjj8Ah5HJDwPLPAXb4'
//  PRODUCT 'AIzaSyBjb_zoxIWFKIa92maBbXYMhJtLWFPrD-w'

export const SETTING = {
    "MAP_CENTER_X": 139.76659754078753,
    "MAP_CENTER_Y": 35.681186550797065,
    "MAP_SCALE": 14
}

export const API_NAME = {
    STATIC_MAP: 'STATIC_MAP', // https://developers.google.com/maps/billing/gmp-billing#static-maps
    DIRECTION: 'DIRECTION', // https://developers.google.com/maps/billing/gmp-billing#directions
    PLACE: 'PLACE', // https://developers.google.com/maps/billing/gmp-billing#basic-data
}
